import {useEffect, useState, type RefObject} from 'react';

function useVideoCues(ref: RefObject<HTMLVideoElement | null>) {
  const [currentTime, setCurrentTime] = useState(0);
  const [hasEnded, setHasEnded] = useState(false);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;

    let isActive = true;
    const handleTimeUpdate = () => setCurrentTime(video.currentTime);
    const handleEnded = () => setHasEnded(true);

    video.addEventListener('timeupdate', handleTimeUpdate);
    video.addEventListener('ended', handleEnded);
    video.addEventListener('error', handleEnded);
    video.play()?.catch(() => {
      if (isActive) setHasEnded(true);
    });
    return () => {
      isActive = false;
      video.removeEventListener('timeupdate', handleTimeUpdate);
      video.removeEventListener('ended', handleEnded);
      video.removeEventListener('error', handleEnded);
    };
  }, [ref]);

  return {currentTime, hasEnded};
}

export {useVideoCues};
